import React from "react";

import Food from "./Component/Food";
import Category from "./Component/Category";

function App() {
  return (
    <div>
      <Food/>
      <Category/>
    </div>
  );
}

export default App;
